export default __webpack_public_path__ + "static/char-v-13-cfeade74a8f1e818c427d3be4f58d14f.png";